import Debug from 'debug';
import { QuizPlayerStateMachineAbstractState,
         QuizPlayerStateMachineCommonEvents } from './quiz-player-state-machine-state'
import { QuizPlayerStateMachineData } from '../data';

const debug = Debug('quiz-player-canceled-state')

export class QuizPlayerCanceledState {

  public readonly name = 'canceled'
  stateEvents = {}

  constructor(private state: QuizPlayerStateMachineData) {
  }

  enter() {
    debug('enter')
    this.state.goToCanceled()
  }

  exit() {
    debug('exit')
  }

  cancel() {
    debug('cancel')
    // NOP
  }
}
